import { Tag, Nullable } from "@brg/api";

/**
 * Тег статус - удаленный
 *
 * @param v
 * @constructor
 */
 export const TagStatusDeleted = (
    v: Nullable<Tag | Tag<"Global">>
  ): boolean => !!v && v.status !== 1;
  import { Tag, Nullable } from "@brg/api";

/**
 * Тег статус - удаленный
 *
 * @param v
 * @constructor
 */
 export const TagStatusDeleted = (
    v: Nullable<Tag | Tag<"Global">>
  ): boolean => !!v && v.status !== 1;
  